import { Button, Group, Modal, Paper, Stack, Text } from "@mantine/core";

import RoleBadge from "../../RoleBadges";
import { AccountIdentity } from "./AccountIdentity";

// Adding an existing account is immediate, so this is where the owner sees
// who the email belongs to and what adding does to that account before
// anything happens. `account` is kept while the modal closes so the content
// does not vanish mid-transition.
export default function AddExistingAccountModal({
  opened,
  account,
  email,
  workspaceName,
  sendEmail = true,
  isAdding,
  onConfirm,
  onClose,
}) {
  if (!account) {
    return null;
  }

  const isAttendee = account.role === "member";
  const firstName = account.firstName || "They";
  const workspace = workspaceName ?? "this workspace";

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Add to workspace"
      centered
      closeOnClickOutside={!isAdding}
      closeOnEscape={!isAdding}
    >
      <Stack gap="md">
        <Paper withBorder radius="md" p="md">
          <AccountIdentity
            user={{ ...account, email }}
            size="lg"
            rightSection={<RoleBadge roleName={account.role} />}
          />
        </Paper>

        <Text size="sm">
          {isAttendee
            ? `${firstName} has an attendee account. Adding it makes them a workspace admin who can manage every event in ${workspace}.`
            : `This account already has admin access and will be added to ${workspace} right away.`}
        </Text>

        <Text size="sm" c="dimmed">
          {sendEmail
            ? `${firstName} will get an email letting them know.`
            : "No email will be sent."}
        </Text>

        <Group justify="flex-end" mt="xs">
          <Button variant="default" onClick={onClose} disabled={isAdding}>
            Cancel
          </Button>
          <Button onClick={onConfirm} loading={isAdding}>
            Add to workspace
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
